module.exports = __webpack_public_path__ + "static/media/6.85c13e47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/6.jpg
// module id = 167
// module chunks = 0